const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Top Five directive to display a list of the 5 most Viewed, or Liked, or Shared contents
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 * @argument {Resource} Overview the resource defined to get Overview view data
 */
app.directive('contenteditable', ['$sce', function ($sce) {
    return {
      restrict: 'A', // only activate on element attribute
      require: '?ngModel', // get a hold of NgModelController
      link: function (scope, element, attrs, ngModel) {
        function read() {
          var html = element.html();
          // When we clear the content editable the browser leaves a <br> behind
          // If strip-br attribute is provided then we strip this out
          if (attrs.stripBr && html === '<br>') {
            html = '';
          }
          ngModel.$setViewValue(html);
        }

        if (!ngModel)
          return; // do nothing if no ng-model

        // Specify how UI should be updated
        ngModel.$render = function () {
          if (ngModel.$viewValue !== element.html()) {
            element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
          }
        };

        // Listen for change events to enable binding
        element.on('blur keyup change', function () {
          scope.$apply(read);
        });
        read(); // initialize
      }
    };
  }]).filter('words', function () {
  return function (input, words) {
    if (isNaN(words)) {
      return input;
    }
    if (words <= 0) {
      return '';
    }
    if (input) {
      var inputWords = input.split(/\s+/);
      if (inputWords.length > words) {
        input = inputWords.slice(0, words).join(' ') + '\u2026';
      }
    }
    return input;
  };
});